import { Container, Button } from "react-bootstrap";
import { FaChartLine, FaUsers, FaBell } from "react-icons/fa";
import "../../styles/MentorShip.css";

const stories = [
  {
    icon: <FaChartLine />,
    title: "The WISE Path: Those Who Have Been There",
    desc: "Experienced mentors and industry leaders reflect on defining moments, challenges, and lessons that shaped their journeys.",
    more: "These sessions offer clarity, perspective, and inspiration for individuals navigating similar career paths, decisions, and transitions.",
    iconBg: "icon-purple",
  },
  {
    icon: <FaUsers />,
    title: "WiSE Voices: Those Who Are Becoming",
    desc: "WiSE members share their stories of learning, growth, and resilience.",
    more: "This format creates space for relatability, peer learning, and collective strength through shared experiences and community dialogue.",
    iconBg: "icon-blue",
  },
  // {
  //   icon: <FaBell />,
  //   title: "Coming Soon",
  //   desc: "WiSE Storytelling sessions under The WISE Path and WiSE Voices are launching soon.",
  //   more: "Stay tuned for session announcements, schedules, and participation details — and get ready to listen, share, and grow with the WiSE community.",
  //   iconBg: "icon-warning",
  // },
];

const StoryTellingCards = () => {
  return (
    <>
    <section className="mentorship-formats-section">
      <Container>
        <h2 className="mentor-section-title wise-secondary-gradient">
          STORYTELLING FORMATS
        </h2>
        <p className="text-secondary mentor-section-subtitle">
          Stories that inspire, connect, and empower
        </p>

        {stories.map((item, index) => (
          <div key={index} className="mentor-format-card hover-effect-only">
            <div className={`mentor-icon-box ${item.iconBg}`}>{item.icon}</div>

            <div className="text-secondary format-content">
              <h5>{item.title}</h5>
              <p>{item.desc}</p>
              <p className="format-more">{item.more}</p>
            </div>
          </div>
        ))}
      </Container>
    </section>

     {/* COMING SOON SECTION */}
<section className="py-5 position-relative overflow-hidden">
  {/* Background Image */}
  <img
    src="../assets/projects/ownprojectsbg.png"
    alt="Coming Soon Background"
    className="position-absolute top-0 start-0 w-100 h-100"
    style={{ objectFit: "cover", zIndex: 0 }}
  />

  {/* Dark Overlay */}
  <div
    className="position-absolute top-0 start-0 w-100 h-100"
    style={{
      backgroundColor: "rgba(0,0,0,0.75)",
      zIndex: 1,
    }}
  />

  {/* Content */}
  <Container className="position-relative d-flex justify-content-center">
    <div
      className="text-white text-center p-5"
      style={{ maxWidth: "900px", zIndex: 2 }}
    >
      <h2 className="wise-secondary-gradient fw-bold">
        Coming Soon!
      </h2>

      <p className="mt-3">
        WiSE Storytelling sessions under The WISE Path and WiSE Voices are launching soon. <br />
        Stay tuned for session announcements, schedules, and participation details — 
        and get ready to listen, share, and grow with the WiSE community.
      </p>
    </div>
  </Container>
</section>
    </>
  );
};

export default StoryTellingCards;
